import { useState } from "react";
import { BookOpen, ChevronDown, ChevronUp, CheckCircle2 } from "lucide-react";

const LEVEL_COLORS = { 1: "#E0162B", 2: "#F59E0B", 3: "#3B82F6", 4: "#10B981" };

export function RubricPanel({ levels = [], selected, onPick, testid, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);
  const meaningful = levels.some((l) => l.label && !/^Nivel \d$/.test(l.label.trim()));
  if (!meaningful) return null;
  const byScore = (n) => levels.find((l) => l.score === n);
  return (
    <div className="mt-2" data-testid={testid}>
      <button type="button" onClick={() => setOpen(!open)}
        className="inline-flex items-center gap-1.5 text-[11px] font-bold text-[var(--lala-blue)] hover:underline"
        data-testid={`${testid}-toggle`}>
        <BookOpen size={12} />
        {open ? "Ocultar criterios de calificación" : "Ver criterios de calificación"}
        {open ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
      </button>
      {open && (
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-2 mt-2">
          {[1, 2, 3, 4].map((n) => {
            const lv = byScore(n);
            const isSel = Number(selected) === n;
            return (
              <button key={n} type="button"
                onClick={() => onPick && onPick(n)}
                disabled={!onPick}
                data-testid={`${testid}-nivel-${n}`}
                className={`text-left rounded-lg border p-2.5 transition-all ${
                  isSel
                    ? "bg-[var(--lala-blue)] text-white border-[var(--lala-blue)] shadow-md"
                    : "bg-white border-[var(--line)] hover:border-[var(--lala-blue)] hover:shadow-sm"
                } ${onPick ? "cursor-pointer" : "cursor-default"}`}>
                <div className="flex items-center justify-between mb-1">
                  <span className={`text-[10px] font-bold uppercase tracking-wider ${isSel ? "text-white" : ""}`}
                    style={isSel ? {} : { color: LEVEL_COLORS[n] }}>
                    Nivel {n}
                  </span>
                  {isSel && <CheckCircle2 size={13} className="text-white" />}
                </div>
                <div className={`text-[11px] leading-snug whitespace-pre-line ${isSel ? "text-white/95" : "text-[var(--ink-soft)]"}`}>
                  {lv?.label || "—"}
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
